export function stringCompare(a: string, b: string): number {
  if (a && b) {
    return a.localeCompare(b);
  }

  return (a == null) ? 1 : -1;
}

export function dateCompare(a: Date, b: Date): number {
  if (a && b) {
    return a.getTime() - b.getTime();
  }

  return (a == null) ? 1 : -1;
}

export function numberCompare(a: number, b: number): number {
  if ((a !== null) && (b !== null)) {
    return b - a;
  }

  return (a == null) ? 1 : -1;
}

export function booleanCompare(a: boolean, b: boolean): number {
  if ((a !== null) && (b !== null)) {
    return Number(b) - Number(a);
  }

  return (a == null) ? 1 : -1;
}
